import { Stack } from '@mui/material'
import { type FC } from 'react'
import { gql } from '__generated__'
import { GetDegreeTypes } from 'shared/graphql/degreesTypes.gql'
import { type CandidateFilterState } from 'shared/hooks/candidateSearchUrlState'
import { IdFilter, ExcludeIdChipFilter, StringFilter } from './FilterPrimitives'
import { GpaFilter, GraduationDateFilter } from './CandidateMinimalFilters'

const GetMajorOptions = gql(/* GraphQL */ `
    query GetMajorOptionsMinimal {
        majors {
            id
            value
        }
    }
`)

const GetAllCollegeNames = gql(/* GraphQL */ `
    query GetAllCollegeNames {
        allCollegeNames
    }
`)

interface EducationFilterSectionProps {
    filters: CandidateFilterState
    updateFilters: (patch: Partial<CandidateFilterState>) => void
}

export const EducationFilterSection: FC<EducationFilterSectionProps> = ({
    filters,
    updateFilters,
}) => {
    return (
        <Stack gap={2.5} sx={{ p: 2 }}>
            <StringFilter
                label="Undergrad College"
                query={GetAllCollegeNames}
                extractOptions={(d) => d?.allCollegeNames ?? []}
                value={filters.undergradCollegeNames}
                onChange={(undergradCollegeNames) =>
                    updateFilters({ undergradCollegeNames })
                }
            />
            <StringFilter
                label="Graduate College"
                query={GetAllCollegeNames}
                extractOptions={(d) => d?.allCollegeNames ?? []}
                value={filters.graduateCollegeNames}
                onChange={(graduateCollegeNames) =>
                    updateFilters({ graduateCollegeNames })
                }
            />
            <GraduationDateFilter
                gte={filters.graduationRangeGte}
                lte={filters.graduationRangeLte}
                educationType={filters.graduationEducationType}
                onChange={(
                    graduationRangeGte,
                    graduationRangeLte,
                    graduationEducationType
                ) =>
                    updateFilters({
                        graduationRangeGte,
                        graduationRangeLte,
                        graduationEducationType,
                    })
                }
            />
            <GpaFilter
                min={filters.gpaRangeMin}
                max={filters.gpaRangeMax}
                noGpaMode={filters.gpaNoGpaMode}
                onChange={(gpaRangeMin, gpaRangeMax) =>
                    updateFilters({ gpaRangeMin, gpaRangeMax })
                }
                onChangeNoGpaMode={(gpaNoGpaMode) =>
                    updateFilters({ gpaNoGpaMode })
                }
                onClear={() =>
                    updateFilters({
                        gpaRangeMin: undefined,
                        gpaRangeMax: undefined,
                        gpaNoGpaMode: undefined,
                    })
                }
            />
            <ExcludeIdChipFilter
                label="Degree"
                query={GetDegreeTypes}
                extractOptions={(d) => d?.degreeTypes ?? []}
                value={filters.degreeTypeIds}
                valueNot={filters.degreeTypeIdsNot}
                onChange={(degreeTypeIds, degreeTypeIdsNot) =>
                    updateFilters({ degreeTypeIds, degreeTypeIdsNot })
                }
            />
            <IdFilter
                label="Major"
                query={GetMajorOptions}
                extractOptions={(d) => d?.majors ?? []}
                value={filters.majorIds}
                onChange={(majorIds) => updateFilters({ majorIds })}
            />
        </Stack>
    )
}
